import { Component } from '@verndale/core';
import Swiper, { Navigation } from 'swiper';

Swiper.use([Navigation]);

import Dropdown from '../../components/dropdown';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      form: this.el.querySelector('form'),
      inputs: this.el.querySelectorAll(
        '.lodging-search__filter--textbox input[type=text]'
      ),
      pageInput: this.el.querySelector('#pageNumber'),
      locationsDropdown: this.el.querySelector('#location'),
      stylesDropdown: this.el.querySelector('#style'),
      unitTypesDropdown: this.el.querySelector('#unitType'),
      amenitiesDropdown: this.el.querySelector('#amenities'),
      sortDropdown: this.el.querySelector('#sortBy'),
      resetBtn: this.el.querySelector('.lodging-search__filters-reset'),
      resultImages: this.el.querySelectorAll('.lodging-search__item-images'),
      pagination: this.el.querySelector('.pagination ul')
    };

    this.currentPage = parseInt(this.el.dataset.page);
    this.totalPages = parseInt(this.el.dataset.totalPages);

    this.dom.locationsDropdown && new Dropdown(this.dom.locationsDropdown);
    this.dom.stylesDropdown && new Dropdown(this.dom.stylesDropdown);
    this.dom.unitTypesDropdown && new Dropdown(this.dom.unitTypesDropdown);
    this.dom.amenitiesDropdown && new Dropdown(this.dom.amenitiesDropdown);

    if (this.dom.sortDropdown) {
      this.dom.sort = new Dropdown(this.dom.sortDropdown);
      this.dom.sort.on('option', () => {
        this.dom.form.submit();
      });
    }

    if (
      [...this.dom.inputs].some(input => input.value) ||
      this.dom.locationsDropdown?.value ||
      this.dom.stylesDropdown?.value ||
      this.dom.unitTypesDropdown?.value ||
      this.dom.amenitiesDropdown?.value
    ) {
      this.dom.resetBtn.style.display = 'block';
    }

    this.dom.resultImages.forEach(carousel => this.initCarousel(carousel));

    if (this.dom.pagination) {
      this.buildPagination();
    }
  }

  addListeners() {
    this.dom.resetBtn.addEventListener('click', this.handleReset.bind(this));

    this.dom.inputs.forEach(input => {
      if (input.value) {
        input.parentNode.classList.add('active');
      }

      input.addEventListener('focus', e => {
        e.target.parentNode.classList.add('active');
      });

      input.addEventListener('blur', e => {
        if (!e.target.value) {
          e.target.parentNode.classList.remove('active');
        }
      });
    });
  }

  initCarousel(el) {
    new Swiper(el, {
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev')
      }
    });
  }

  handleReset() {
    window.location.href = window.location.href;
  }

  handlePaginate(page) {
    this.dom.pageInput.value = page;
    this.dom.form.submit();
  }

  buildPagination() {
    if (this.currentPage > 1) {
      this.addPrevPage();
    }
    this.addPages();
    if (this.currentPage < this.totalPages) {
      this.addNextPage();
    }
  }

  addPrevPage() {
    const paginationPrev = document.createElement('button');
    paginationPrev.classList.add('pagination__arrow__btn');
    paginationPrev.setAttribute('role', 'button');
    paginationPrev.setAttribute('aria-label', 'Go to Previous Page');
    paginationPrev.innerHTML = '<svg><title>previous</title><use xlink:href="#chevron-right" /></svg>';
    paginationPrev.addEventListener('click', () =>
      this.handlePaginate(this.currentPage - 1)
    );

    const paginationPrevContainer = document.createElement('li');
    paginationPrevContainer.classList.add('pagination__arrow');
    paginationPrevContainer.classList.add('left');
    paginationPrevContainer.appendChild(paginationPrev);

    this.dom.pagination.appendChild(paginationPrevContainer);
  }

  addNextPage() {
    const paginationNext = document.createElement('button');
    paginationNext.classList.add('pagination__arrow__btn');
    paginationNext.setAttribute('role', 'button');
    paginationNext.setAttribute('aria-label', 'Go to Next Page');
    paginationNext.innerHTML = '<svg><title>next</title><use xlink:href="#chevron-right" /></svg>';
    paginationNext.addEventListener('click', () =>
      this.handlePaginate(this.currentPage + 1)
    );

    const paginationNextContainer = document.createElement('li');
    paginationNextContainer.classList.add('pagination__arrow');
    paginationNextContainer.classList.add('right');
    paginationNextContainer.appendChild(paginationNext);

    this.dom.pagination.appendChild(paginationNextContainer);
  }

  addPages() {
    const keys = [...Array(this.totalPages).keys()];

    keys.forEach(page => {
      const pageNum = page + 1;
      const padding = 2;
      const maxValue = 5;
      const min =
        this.currentPage - padding < this.totalPages - 4
          ? this.currentPage - padding
          : this.totalPages - 4;
      const max =
        this.currentPage + padding > 5 ? this.currentPage + padding : maxValue;

      if (pageNum === this.currentPage - padding && pageNum > 1) {
        const dotsEl = document.createElement('li');
        dotsEl.innerHTML = '...';
        this.dom.pagination.appendChild(dotsEl);
      }

      if (pageNum === 1 || pageNum === this.totalPages) {
        this.addPage(pageNum);
      } else if (pageNum > min && pageNum < max) {
        this.addPage(pageNum);
      }

      if (pageNum === max && pageNum < this.totalPages) {
        const dotsEl = document.createElement('li');
        dotsEl.innerHTML = '...';
        this.dom.pagination.appendChild(dotsEl);
      }
    });
  }

  addPage(pageNum) {
    const pageEl = document.createElement('button');
    pageEl.innerHTML = pageNum;
    pageEl.classList.add('pagination__item-btn');
    pageEl.setAttribute('role', 'button');
    pageEl.setAttribute('aria-label', `Goto Page ${pageNum}`);
    pageEl.setAttribute('aria-current', this.currentPage === pageNum);
    pageEl.addEventListener('click', () => this.handlePaginate(pageNum));

    const pageElContainer = document.createElement('li');
    pageElContainer.classList.add('pagination__item');
    pageElContainer.appendChild(pageEl);

    this.dom.pagination.appendChild(pageElContainer);
  }
}

export default Module;
